import React from 'react'
import { Box, Divider, useTheme } from '@mui/material'
import SummaryItem from './SummaryItem'
import { CashAmount } from '../../../swagger'
import { useTranslation } from 'react-i18next'

interface FinancialSummaryProps {
  totalTutorsOwe: CashAmount
  totalDirectorOwe: CashAmount
  totalFamiliesOwe: CashAmount
  totalFamiliesOweDirector: CashAmount
}

const VerticalDivider = () => (
  <Divider orientation="vertical" flexItem sx={{ opacity: 0.3 }} />
)

const FinancialSummary: React.FC<FinancialSummaryProps> = ({
  totalTutorsOwe,
  totalDirectorOwe,
  totalFamiliesOwe,
  totalFamiliesOweDirector,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        mt: 1,
        justifyContent: 'flex-end',
        pr: 2,
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 1,
          pr: 0,
        },
      }}
    >
      <SummaryItem
        label={t('FinancialSummary.DirectorOwesCC.Label', 'Director Owes CC')}
        value={totalDirectorOwe}
      />
      <VerticalDivider />
      <SummaryItem
        label={t(
          'FinancialSummary.TutorsOweDirector.Label',
          'Tutors Owe Director'
        )}
        value={totalTutorsOwe}
      />
      <VerticalDivider />
      <SummaryItem
        label={t(
          'FinancialSummary.FamiliesOweTutors.Label',
          'Families Owe Tutors'
        )}
        value={totalFamiliesOwe}
      />
      <SummaryItem
        label={t(
          'FinancialSummary.FamiliesOweDirectors.Label',
          'Families Owe Directors'
        )}
        value={totalFamiliesOweDirector}
      />
    </Box>
  )
}

export default FinancialSummary
